import type { FC } from "react";
import React from "react";

import { PageContainer } from "@react/web/app";

import { MetricsView } from "../features/metrics/index.ts";

export const Metrics: FC = () => (
  <PageContainer>
    <MetricsView />
  </PageContainer>
);
